import {
  HealthDiaryPathsEnum,
  HealthDiaryRoutesEnum,
} from "@ch/router/HealthDiaryRoutes/enums.ts";
import RespirationPageLazy from "@ch/pages/RespirationPage";
import RespirationHistoryPageLazy from "@ch/pages/RespirationPage/RespirationHistoryPageLazy.tsx";
import RespirationLogPageLazy from "@ch/pages/RespirationPage/RespirationLogPageLazy.tsx";
import postHogFeatureFlagKeys from "@ch/helpers/utils/postHogAnalytics/postHogFeatureFlagKeys.ts";
import FeatureFlagRouteGate from "@ch/components/Gate/FeatureFlagRouteGate.tsx";

export const respirationRoutes = [
  {
    path: HealthDiaryPathsEnum.RESPIRATION_HISTORY,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <RespirationHistoryPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Respiration History",
      }),
      crumb: () => ({
        title: "Respiration History",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_RESPIRATION_HISTORY,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.RESPIRATION_LOG,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <RespirationLogPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Respiration Log",
      }),
      crumb: () => ({
        title: "Log Respiration",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_RESPIRATION_LOG,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.RESPIRATION,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <RespirationPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Respiration",
      }),
      crumb: () => ({
        title: "Respiration",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_RESPIRATION,
      }),
    },
  },
];
